import React from 'react'
import { Link, graphql, useStaticQuery } from 'gatsby'
import tw, { styled } from 'twin.macro'
import PropTypes from 'prop-types'

const Section = styled.section`
	${tw`flex flex-col items-center w-full py-12 px-4`}
`

const Heading = styled.h2`
	${tw`text-black font-black text-left mb-8`}
	font-weight: 800;
	font-size: clamp(1.4rem, 3vw, 2.8rem);
	font-family: Flexo, system-ui, sans-serif !important;
`

const HeadingLight = styled.span`
	color: #aaa;
	font-size: clamp(1.4rem, 3vw, 2.8rem);
	font-family: Flexo, system-ui, sans-serif !important;
`

const HeadingBold = styled.span`
	color: #111;
	font-size: clamp(1.4rem, 3vw, 2.8rem);
	font-family: Flexo, system-ui, sans-serif !important;
`

const Inner = styled.div`
	${tw`flex flex-col w-full`}
	max-width: 1100px;
`

const Grid = styled.div`
	${tw`grid grid-cols-1 md:grid-cols-3 gap-6 w-full`}
`

const Card = styled.div`
	${tw`flex flex-col`}
`

const CardImage = styled.img`
	${tw`w-full object-cover`}
	border-radius: 40px;
	aspect-ratio: 4 / 3;
`

const CardTitle = styled.h3`
	${tw`font-bold text-black mt-4 mb-1 leading-snug`}
	font-size: clamp(1.3rem, 2.2vw, 1.6rem);
	font-family: Flexo, system-ui, sans-serif !important;
	font-weight: 800;
`

const ReadMore = styled(Link)`
	${tw`font-semibold text-black text-lg`}
	text-decoration: none;
	font-family: "Montserrat", sans-serif;
	font-weight: 700;
	&:hover {
		text-decoration: underline;	
	}
	
`

const Blog = ({ locale }) => {
	const localePrefix = locale === 'en-AU' ? '' : `/${locale}`

	const data = useStaticQuery(graphql`
		query HomeBlogPosts {
			allContentfulPost(
				filter: {
					slug: { nin: [null] }
					node_locale: { eq: "en-AU" }
					contentful_id: {
						in: [
							"21t52gXH9FkV2F2nyrKWxv"
							"tLudgR0pfdjUVFmskRMBD"
							"25QAKGNh2BXTKASK9eHmN2"
							
						]
					}
				}
			) {
				nodes {
					slug
					dateAndTime
					contentful_id
					seoTitle
					image {
						file {
							url
						}
					}
				}
			}
		}
	`)

	const idOrder = [
		"21t52gXH9FkV2F2nyrKWxv",
		"tLudgR0pfdjUVFmskRMBD",
		"25QAKGNh2BXTKASK9eHmN2",
	]

	const posts = [...data.allContentfulPost.nodes].sort(
		(a, b) => idOrder.indexOf(a.contentful_id) - idOrder.indexOf(b.contentful_id)
	)

	return (
		<Section>
			<Inner>
				<Heading><HeadingLight>Our </HeadingLight><HeadingBold>Blog</HeadingBold></Heading>
				<Grid>
					{posts.map((post) => (
						<Card key={post.contentful_id}>
							<Link to={`/${post.slug}/`}>
								<CardImage
									src={`https:${post.image.file.url}?w=600&h=450&q=70&fm=webp&fit=fill&f=center`}
									alt={post.seoTitle}
								/>
							</Link>
							<CardTitle>{post.seoTitle}</CardTitle>
							<ReadMore to={`/${post.slug}/`}>Read More</ReadMore>
						</Card>
					))}
				</Grid>
			</Inner>
		</Section>
	)
}

Blog.propTypes = {
	locale: PropTypes.string.isRequired,
}

export default Blog
